var _path, _rect, _rect2, _line, _line2, _line3, _line4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDritareNjeKraheshe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 125,
    viewBox: "0 0 84 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9802 14.6778H12.5851V111.453H70.9802V14.6778ZM0 0.620911V125H83.5654V0.620911H0Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.3564,
    y: 15.5367,
    width: 56.8529,
    height: 95.6935,
    fill: "url(#paint0_linear_1018_30)",
    stroke: "#DEDEDE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.8823,
    y: 56.8859,
    width: 3.5915,
    height: 12.359,
    rx: 1.79575,
    stroke: "#DEDEDE"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 98.2586,
    y2: -0.5,
    transform: "matrix(0.273021 -0.962008 0.91378 0.406209 14.6636 111.322)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 98.5609,
    y2: -0.5,
    transform: "matrix(0.283161 0.959072 -0.914568 0.404432 40.54 16.315)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 71.1668,
    y2: -0.5,
    transform: "matrix(-0.758246 -0.651969 0.481206 -0.876608 69.0049 110.543)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -0.5,
    x2: 72.5377,
    y2: -0.5,
    transform: "matrix(0.744014 -0.668164 0.497387 0.867529 14.6636 65.1161)",
    stroke: "#C6C6C6",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1018_30",
    x1: 78.4807,
    y1: -90.4944,
    x2: 32.876,
    y2: 108.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDritareNjeKraheshe);
export default __webpack_public_path__ + "static/media/dritare-nje-kraheshe.4d418f296a1c5e823dcec41037cc3c1a.svg";
export { ForwardRef as ReactComponent };